import React from 'react'
import get from 'lodash/get'
import { OverallButton } from './overall'
import { LOBOverviewButton } from './lob-overview'

export default class ButtonGroup extends React.Component {
  render() {
    const activeTab = get(this.props, 'activeTab')
    switch (activeTab) {
      case 1: return (
        <OverallButton
          period={ get(this.props, 'period') }
          lobs={ get(this.props, 'lobs') }
          lob_ids={ get(this.props, 'lob_ids') }
          setDefault={ get(this.props, 'setDefault') }
          selectedIDs={ get(this.props, 'selectedIDs') }
          efficiencyResources={ get(this.props, 'efficiencyResources') }
          handlePeriod={ get(this.props, 'handlePeriod') }
          handleSelectLOB={ get(this.props, 'handleSelectLOB') }
        />
      )
      case 2: return (
        <LOBOverviewButton
          lobs={ get(this.props, 'lobs') }
          startDateOverview={ get(this.props, 'startDateOverview') }
          endDateOverview={ get(this.props, 'endDateOverview') }
          lobOverview={ get(this.props, 'lobOverview') }
          handleInputOverview={ get(this.props, 'handleInputOverview') }
          location={ get(this.props, 'location') }
          path={ get(this.props, 'path') }
        />
      )
      default: return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/tab/button-group/index.js